import type { Rule } from 'antd/es/form';
import type { TFunction } from 'i18next';

export const PASSWORD_MIN_LENGTH = 8;

/** Reguły pól ekranów /auth: komunikat mówi, co wpisać, a nie tylko że „pole jest wymagane”. */
export function emailRules(t: TFunction): Rule[] {
  return [
    { required: true, whitespace: true, message: t('auth:screens.validation.emailRequired') },
    {
      type: 'email',
      transform: (value: string) => value?.trim(),
      message: t('auth:screens.validation.emailInvalid'),
    },
  ];
}

export function newPasswordRules(t: TFunction): Rule[] {
  return [
    { required: true, message: t('auth:screens.validation.passwordRequired') },
    { min: PASSWORD_MIN_LENGTH, message: t('auth:screens.validation.passwordMin') },
  ];
}

/** Hasło logowania może składać się ze spacji (tak jak dotąd) — wtedy `allowWhitespace`. */
export function requiredRule(message: string, { allowWhitespace = false } = {}): Rule[] {
  return [{ required: true, whitespace: !allowWhitespace, message }];
}

/** Zgoda (checkbox) musi być zaznaczona. */
export function acceptedRule(message: string): Rule[] {
  return [
    {
      validator: (_rule, value: boolean) =>
        value ? Promise.resolve() : Promise.reject(new Error(message)),
    },
  ];
}
